import React from "react";
import Navbar from "../Components/Navbar";
import subpagebanner from "../Assets/subpagebanner.png";
import event from "../Assets/event.png";
import footer from "../Assets/footer.png";

const About = () => {
  return (
    <div className="App">
      <Navbar />
      <img src={subpagebanner} alt="" />
      <div className="home-container"></div>
      <div className="bodycopy-container">
        <h1 className="primary-header ">Event</h1>

        <div className="center-text"></div>
        <br />

        {/*       
          <iframe
            className="player"
            src="https://www.youtube.com/embed/7I9Imt6b2VI?si=UBOQ8z23-UEWEwHf"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

        */}

        <table className="table-style">
          <tr>
            <th className="table-style-cell3">DATE</th>
            <th className="table-style-cell3">EVENT</th>
          </tr>
          <tr className="table-style-cell1">
            <td>
              <h3>29 Jan 2026 Thursday</h3>
            </td>
            <td>
              <p className="table-style-cell2">
                <h3>KICK-OFF</h3>
                <br />
                Time: 6:30pm SGT
                <br />
                Venue: Shaw Foundation Alumni House Auditorium, Level 2
                <br />
                11 Kent Ridge Dr, Singapore 119244
                <br />
                <br />
                <p className="">
                  Zoom Recording: <br />
                  <a href="https://nus-sg.zoom.us/rec/share/7Eblc1KigLlzVDgwTt6IvrKr-1RsCEk3_erca6OAzG9QxWI1ee52NOUwBL5vZ2Iv.S5VdIa6P9Fy1wYgZ ">
                    https://bit.ly/4qcqygJ
                  </a>{" "}
                  <br />
                  <br />
                  Passcode: 2?1^SKq?
                  <br />
                  <br />
                  Presentation Slide:{" "}
                  <a href="https://drive.google.com/file/d/1axW7aiVC26HxwmuZHf0UPFnuUekZxyJV/view?usp=sharing">
                    https://drive.google.com/file/d/1axW7aiVC26HxwmuZHf0UPFnuUekZxyJV/view?usp=sharing
                  </a>{" "}
                </p>
              </p>
            </td>
          </tr>
          <tr className="table-style-cell1">
            <td>
              <h3>5 Feb 2026 Thursday</h3>
            </td>
            <td>
              <p className="table-style-cell2">
                <h3>ENABLEMENT SESSION 1</h3>
                <br />
                Time: 6:30pm SGT
                <br />
                Venue: NUS Hon Sui Sen Auditorium 1 Hon Sui Sen Drive Singapore
                117588
                <br />
                <br />
                Zoom Recording: <br />
                <a href="https://nus-sg.zoom.us/rec/share/4jNLpJAPfUBOfw1M0pGqa5YDJYftzZjHVlzJa9WneCSuFiKKsrUN6xgwT46TwT8b.evq6u0qtEwRra9jO">
                  https://bit.ly/4alyqGu
                </a>{" "}
                <br />
                <br />
                Passcode: N0vT.2!&
                <br />
                <br />
                Presentation Slide:{" "}
                <a href="https://drive.google.com/file/d/1JvHsSUWbeomhtcOkpROrZDeWQY5Btnan/view?usp=sharing">
                  https://drive.google.com/file/d/1JvHsSUWbeomhtcOkpROrZDeWQY5Btnan/view?usp=sharing
                </a>{" "}
              </p>
            </td>
          </tr>

          <tr className="table-style-cell1">
            <td>
              <h3>12 Feb 2026 Thursday</h3>
            </td>
            <td>
              <p className="table-style-cell2">
                <h3>ENABLEMENT SESSION 2</h3>
                <br />
                Time: 2:00-4:00pm SGT
                <br />
                <br />
                Zoom Recording:{" "}
                <a href="https://nus-sg.zoom.us/rec/share/8yfrkVv4LffWD7uJlHVjnowwSnMhQbqQdagx6jv7exPe8D4PNKxVXzfugBEYpfIX.SRE1B4nucQ8nggyS">
                  https://bit.ly/4rlArdo
                </a>
                <br />
                <br />
                Passcode: m8GJm?jW
                <br />
                <br />
                Presentation Slide:{" "}
                <a href="https://drive.google.com/file/d/1CV5QeJH_TaaOCB_mEE-t0xpgu4wNjOf3/view?usp=sharing">
                  https://drive.google.com/file/d/1CV5QeJH_TaaOCB_mEE-t0xpgu4wNjOf3/view?usp=sharing
                </a>{" "}
              </p>
            </td>
          </tr>

          <tr className="table-style-cell1">
            <td>
              <h3>11 Apr 2026 Saturday</h3>
            </td>
            <td>
              <p className="table-style-cell2">
                <h3>FINAL</h3>
                <br />
                Time: 9:00am SGT
                <br />
                Venue: Synapxe Terrarium, 1 North Buona Vista Link, #05-01,
                Singapore 139691
                <br />
              </p>
            </td>
          </tr>
        </table>
        <br />
        <br />
        <br />

        <img src={footer} alt="" />
        <br />
        <br />
      </div>
    </div>
  );
};

export default About;
